export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true,
      required: false
    },
    model: {
      type: Object,
      // aby móc używać bez podawania modelu
      default: () => ({
        $schema: {
          title: ''
        }
      }),
      required: false
    },
    boldLabel: {
      type: Boolean,
      default: null,
      required: false
    },
    labelFor: {
      type: String,
      default: undefined,
      required: false
    },
    title: {
      type: String,
      default: undefined,
      required: false
    },
    description: {
      type: Object,
      default: () => ({
        value: undefined,
        tooltip: undefined,
        htmlContent: false,
        newLine: true,
        placement: null
      }),
      required: false
    },
    onlyDescription: {
      type: Boolean,
      default: false
    },
    cursor: {
      type: String,
      default: 'default'
    },
    isHtmlTitle: {
      type: Boolean,
      default: false
    },
    nextNumber: {
      type: Object,
      default: null,
      required: false
    },
    aria: {
      type: String,
      default: ''
    }
  },
  computed: {
    isTitle: {
      get() {
        return !!this.getTitle;
      }
    },
    getTitle: {
      get() {
        if (this.$slots.title && this.$slots.title[0].text.length) {
          return this.$slots.title[0].text;
        } else if (this.title === undefined || this.title === null) {
          return this.model.$schema.title;
        }
        return this.title;
      }
    },
    isDescription: {
      get() {
        return !!this.getDescription;
      }
    },
    getDescription: {
      get() {
        const val = this.$options._componentTag == 'w-description' ? this.value || this.description.value : this.description.value;
        //`this.value` jest zbyt uniwersalne, przez co inny component korzystający z tego mixina, może mieć takie property w innym celu
        if (this.$slots.description && this.$slots.description[0].text.length) {
          return this.$slots.description[0].text;
        } else if (this.model && this.model.$schema && val === undefined) {
          return this.model.$schema.description;
        }
        return val;
      }
    },
    isTooltip() {
      return this.tooltip || this.description.tooltip;
    },
    isHtmlContent() {
      return this.htmlContent || this.description.htmlContent;
    },
    isNewLine() {
      const newLine = this.description.newLine;
      return newLine === null ? !getTooltip : newLine;
    },
    activeAria() {
      if (!this.showLabel) {
        return this.aria;
      } else {
        return undefined;
      }
    }
  }
};
